import { render, staticRenderFns } from "./m-appointment-calendar.vue?vue&type=template&id=023cb58c&scoped=true"
import script from "./m-appointment-calendar.vue?vue&type=script&lang=js"
export * from "./m-appointment-calendar.vue?vue&type=script&lang=js"
import style0 from "./m-appointment-calendar.vue?vue&type=style&index=0&id=023cb58c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023cb58c",
  null
  
)

export default component.exports